import { permissionRequest } from '@/models/permission'
import type { UserPermissionSet } from '@/models/permission'

const URL = '/api/v1/auth/permissions'

export async function fetchUserPermissions(
  scope: string,
): Promise<UserPermissionSet> {
  const data = Object.entries(permissionRequest)
    .map(([key, value]) => ({
      key,
      value: [scope, ...value],
    }))
    .reduce(
      (p, c) => ({ ...p, [c.key]: c.value }),
      <Record<string, string[]>>{},
    )
  try {
    const response = await fetch(URL, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    })
    const res: UserPermissionSet = await response.json()
    return res
  } catch (error) {
    console.error(error)
    throw error
  }
}
